function HasClass( el, cls )
{
    var current = el.getAttribute( "class" );
    return ( ( current != undefined ) && ( current.indexOf( cls ) != -1 ) );
}

function AddClass( el, cls )
{
    if ( el )
    {
        var current = el.getAttribute( "class" );
        if ( ( current == undefined ) || ( current.indexOf( cls ) == -1 ) )
        {
            current += " " + cls;
            el.setAttribute( "class", current );
        }
    }
}
function RemoveClass( el, cls )
{
    if ( el )
    {
        var current = el.getAttribute( "class" );
        if ( current )
        {
            current = current.replace( cls, ' ' );
            el.setAttribute( "class", current );
        }
    }
}
function SearchParentsFor( start, cls, top )
{
    var result;

    var parent = start.parentNode;
    if ( ( parent ) && (  parent.getAttribute ) )
    {
        var pcls = parent.getAttribute( "class" );
        if ( pcls )
        {
            var pclsArray = pcls.split( " " );
            for ( var i = 0; i < pclsArray.length; i++ )
            {
                if ( pclsArray[ i ] == cls )
                {
                    result = parent;
                    break;
                }
            }
        }

        if ( ( !result ) && ( ( !top ) || ( parent != top ) ) )
        {
            result = SearchParentsFor( parent, cls, top );
        }
    }

    return ( result );
}

function RevealMetadataCollection( element )
{
    var container   = SearchParentsFor( element, "collection_metafiield_container" );
    var parent      = container.querySelector( ".collection_metafield_content_container" );
    var child       = container.querySelector( ".collection_metafield_content_inner" );
    var PlusMinus   = container.querySelector( ".circle-plus" );
    RevealMetadata( container, parent, child );
    PlusMinusAnimation( PlusMinus );
}

function RevealMetadata( container, parent, child )
{
    var parentHeight   = parent.offsetHeight;
    var childHeight    = child.offsetHeight;

    if( parentHeight == 0 )
    {
        parent.style.height = childHeight + "px";
    }
    else
    {
        parent.style.height = "0px";
    }

}

function PlusMinusAnimation( element )
{
    console.log( element );
    if( HasClass( element, "opened" ) )
    {
        RemoveClass( element, "opened" );
    }
    else
    {
        AddClass( element, "opened" );
    }
}


